export default __webpack_public_path__ + "static/media/hit.1fd7cca8.wav";